export enum HealthEventType {
  APPOINTMENT = 'appointment',
  VACCINATION = 'vaccination',
  EXAMINATION = 'examination',
  TREATMENT = 'treatment',
  MEDICAL_SERVICE = 'medical_service',
  FINANCIAL_SERVICE = 'financial_service',
  OTHER = 'other'
}

// Interface pour les données de l'API health-events
export interface HealthEventApi {
  _id: string;
  type: string;
  title: string;
  date: string;
  notes: string;
  description: string;
  externalId?: string;
  professionalName: string;
  structureName: string;
  passportNumber: string;
  agendaId?: string;
  doctor?: string;
  reason?: {
    id: string;
    label: string;
    _id: string;
  };
  startTime?: string;
  endTime?: string;
  status: string;
  structure?: {
    id: string;
    name: string;
  };
  paymentId?: string;
  createdBy: string;
  disabled: boolean;
  createdAt: string;
  updatedAt: string;
  __v?: number;
  user?: {
    passportNumber: string;
    firstName: string;
    lastName: string;
  };
  documents?: any[];
  // Propriétés legacy pour compatibilité
  appointment?: {
    _id: string;
    appointmentId: string;
    agendaId: string;
    doctor: string;
    reason: {
      id: string;
      label: string;
      _id: string;
    };
    date: string;
    startTime: string;
    endTime: string;
    passportNumber: string;
    status: string;
    structure: {
      id: string;
      name: string;
    };
    createdAt: string;
    updatedAt: string;
    documents?: any[];
  };
}

// Interface pour les données de l'API appointments
export interface AppointmentApi {
  _id: string;
  type: string;
  title: string;
  date: string;
  notes?: string;
  description: string;
  externalId?: string;
  professionalName: string;
  structureName: string;
  passportNumber: string;
  agendaId: string;
  doctor: string;
  doctorPhoto?: string; // Photo du docteur (optionnelle)
  reason: {
    id: string;
    label: string;
    _id: string;
  };
  startTime: string;
  endTime: string;
  status: string;
  structure: {
    id: string;
    name: string;
  };
  paymentId?: string;
  createdBy: string;
  disabled: boolean;
  createdAt: string;
  updatedAt: string;
  __v: number;
  user: {
    passportNumber: string;
    firstName: string;
    lastName: string;
  };
  documents?: any[];
  // Propriétés legacy pour compatibilité
  appointmentId?: string;
}

// Interface pour la réponse de l'API avec pagination
export interface HealthEventResponse {
  data: HealthEventApi[];
  meta: {
    totalItems: number;
    totalPages: number;
    currentPage: number;
    pageSize: number;
  };
  // Propriété legacy pour compatibilité
  pagination?: {
    total: number;
    page: number;
    limit: number;
    totalPages: number;
  };
}

// Interface pour la réponse des rendez-vous avec pagination
export interface AppointmentResponse {
  data: AppointmentApi[];
  meta: {
    totalItems: number;
    totalPages: number;
    currentPage: number;
    pageSize: number;
  };
  // Propriété legacy pour compatibilité
  pagination?: {
    total: number;
    page: number;
    limit: number;
    totalPages: number;
  };
}

// Interface pour les données transformées utilisées dans le composant
export interface HealthEvent {
  id: string;
  type: HealthEventType;
  title: string;
  description: string;
  date: Date;
  status: 'completed' | 'scheduled' | 'cancelled' | 'pending' | 'pending_payment' | 'confirmed' | 'rejected';
  location?: string;
  doctor?: string;
  doctorPhoto?: string; // Photo du docteur (optionnelle)
  amount?: number;
  currency?: string;
  notes?: string;
  createdAt: Date;
  updatedAt: Date;
  professionalName?: string;
  structureName?: string;
  passportNumber?: string;
  paymentId?: string;
  checkoutLink?: string;
  payment?: any;
  documents?: any[];
  appointment?: any;
  user?: {
    passportNumber: string;
    firstName: string;
    lastName: string;
  };
}

export interface HealthEventFormData {
  type: HealthEventType;
  title: string;
  description: string;
  date: Date;
  location?: string;
  doctor?: string;
  amount?: number;
  currency?: string;
  notes?: string;
}
